import "./GMTChatDashboard.css";

import { useConstants } from "../../constant/constantProvider";
import CardItem from "../CardItem/CardItem";

// assets
import GMT_LOGO from "../../assets/icons/app-icons/gmt-main-logo.svg";
import REVENUE_ICON from "../../assets/images/revenue-insights.svg";
import CUSTOMER_ICON from "../../assets/images/customer-behaviour.svg";

const GMTChatDashboard = ({ routeToGMTChat }) => {
    const { WELCOME_GMT_TEXT, GMT_DESCRIPTION, REVENUE_INSIGHTS, GET_STARTED_GMT, CUSTOMER_BEHAVIOUR_INSIGHTS, REVENUE_INSIGHTS_SUBTITLE, CUSTOMER_BEHAVIOUR_INSIGHTS_SUBTITLE } = useConstants();
    const cards = [
        {
            icon: REVENUE_ICON,
            title: REVENUE_INSIGHTS,
            subtitle: REVENUE_INSIGHTS_SUBTITLE,
        },
        {
            icon: CUSTOMER_ICON,
            title: CUSTOMER_BEHAVIOUR_INSIGHTS,
            subtitle: CUSTOMER_BEHAVIOUR_INSIGHTS_SUBTITLE,
        },
    ];

    return (
        <div className="gmt-dashboard-content">
            <div className="gmt-header">
                <div className="gmt-icon">
                    <img src={GMT_LOGO} alt="gmt-icon" />
                </div>
                <span className="gmt-title">{WELCOME_GMT_TEXT}</span>
                <p className="gmt-subtitle">
                    {GMT_DESCRIPTION}
                </p>
            </div>

            {<div className="cards card-container">
                {cards.map((card, idx) => (
                    <CardItem
                        key={idx}
                        icon={card.icon}
                        title={card.title}
                        subtitle={card.subtitle}
                    />
                ))}
            </div>}
            <button
                className="button-style primary-start-button"
                type="button"
                onClick={routeToGMTChat}
            >
                {GET_STARTED_GMT}
            </button>

        </div>
    );
};

export default GMTChatDashboard;
